var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "Camera",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <g id="svg-fg">
    <path d="M37.18,33.44A5.18,5.18,0,1,1,32,28.22,5.19,5.19,0,0,1,37.18,33.44Z"/>
    <path d="M39.19,33.44A7.19,7.19,0,1,0,32,40.63,7.18,7.18,0,0,0,39.19,33.44Zm4.86,10.81H19.87a3.56,3.56,0,0,1-3.17-1.57,3.48,3.48,0,0,1-.68-2v-13A3.73,3.73,0,0,1,19.55,24c1.21,0,2.37,0,3.58,0,.2,0,.28,0,.36-.2.32-.64.64-1.29,1-1.89a3.59,3.59,0,0,1,3.33-2.17c2.81,0,5.62,0,8.48,0a3.6,3.6,0,0,1,3.17,2c.36.68.72,1.37,1,2a.3.3,0,0,0,.28.16h3.41A3.73,3.73,0,0,1,48,27.86V40.43a3.68,3.68,0,0,1-3.21,3.78A4.37,4.37,0,0,1,44.05,44.25Z"/>
  </g>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/app/assets/icons/camera.svg